import type { ToastSeverity } from "./types";

/** Per-severity auto-dismiss durations (ms). Errors linger longer so they aren't missed. */
export const TOAST_DURATION: Record<ToastSeverity, number> = {
  success: 3000,
  info: 3000,
  warning: 5000,
  error: 6000,
};

/** Fallback duration for the <Toaster/> default; per-severity calls override this. */
export const DEFAULT_TOAST_DURATION = 4000;

/** Max simultaneously-visible toasts before Sonner stacks/collapses the rest. */
export const VISIBLE_TOASTS_CAP = 4;
